import ContextListItemDropdown from "views/Account/Contexts/ListItemDropdown";

import { CellComponentProps } from "./types";

type ContextsListItemActionsDropdownCellProps = CellComponentProps & {
  canManageContexts?: boolean;
};

const ContextsListItemActionsDropdownCell = ({
  context,
  canManageContexts,
}: ContextsListItemActionsDropdownCellProps) => {
  return <ContextListItemDropdown context={context} canManageContexts={!!canManageContexts} />;
};

export default ContextsListItemActionsDropdownCell;
